import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import {
  firefunctions,
  firestore,
  GeoPoint,
  // firestore,
} from "../../../components/firebase/FirebaseProvider";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useData } from "../../../components/firebase/DataProvider";
import Gap from "../../../components/atoms/Gap";
import { useSnackbar } from "notistack";
//material
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";

import {
  Dialog,
  DialogContent,
  Button,
  DialogTitle,
  IconButton,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import useStyles from "./styles/styleDialog";
import Maps from "../../../components/molecules/Maps";

function DialogFormAlamat({ openForm, addToCart, closeForm }) {
  const classes = useStyles();
  const history = useHistory();
  const { alamatRef, alamat_pusat, menu_alamat, profil } = useData();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({
    judul: "",
    judulLainnya: "",
    nama_penerima: "",
    no_telepon: "+62",
    provinsi: {},
    kota: {},
    kecamatan: {},
    kelurahan: {},
    alamat_lengkap: "",
    destination_direction: "",
  });

  const [error, setError] = useState({
    judul: "",
    nama_penerima: "",
    no_telepon: "",
    provinsi: "",
    kota: "",
    kecamatan: "",
    kelurahan: "",
    alamat_lengkap: "",
  });

  const [currentPos, setCurrentPos] = useState(null);

  const position = {
    lat: alamat_pusat?.koordinat?.latitude,
    lng: alamat_pusat?.koordinat?.longitude,
  };

  const [titik_maps, setTitik_maps] = useState(false);

  const togglecheckboxTitikAlamat = (e) => {
    setTitik_maps(e.target.checked);
  };

  const [loadingProvinsi, setLoadingProvinsi] = useState(false);
  const [provinsi, setProvinsi] = useState([]);

  useEffect(() => {
    async function fetchProvinsi() {
      setLoadingProvinsi(true);
      try {
        const getProvinsi = firefunctions.httpsCallable("getProvinsi");

        const response = await getProvinsi();

        setProvinsi(response.data);
      } catch (e) {
        console.log(e.message);
      }
      setLoadingProvinsi(false);
    }

    fetchProvinsi();
  }, []);
  const [loadingKota, setLoadingKota] = useState(false);
  const [kota, setKota] = useState([]);
  useEffect(() => {
    async function fetchKota() {
      setLoadingKota(true);
      try {
        const getKota = firefunctions.httpsCallable("getKota");

        if (form.provinsi.id) {
          const response = await getKota({ provinsi_id: form.provinsi?.id });

          setKota(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKota(false);
    }

    fetchKota();
  }, [form.provinsi.id]);

  const [loadingKecamatan, setLoadingKecamatan] = useState(false);
  const [kecamatan, setKecamatan] = useState([]);

  useEffect(() => {
    async function fetchKecamatan() {
      setLoadingKecamatan(true);
      try {
        const getKecamatan = firefunctions.httpsCallable("getKecamatan");

        if (form.kota.id) {
          const response = await getKecamatan({
            kota_id: form?.kota?.id,
            provinsi_id: form.provinsi?.id,
          });

          setKecamatan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKecamatan(false);
    }

    fetchKecamatan();
  }, [form.kota.id]);

  const [loadingKelurahan, setLoadingKelurahan] = useState(false);
  const [kelurahan, setKelurahan] = useState([]);

  useEffect(() => {
    async function fetchKelurahan() {
      setLoadingKelurahan(true);
      try {
        const getKelurahan = firefunctions.httpsCallable("getKelurahan");

        if (form.kecamatan.id) {
          const response = await getKelurahan({
            kota_id: form?.kota?.id,
            provinsi_id: form.provinsi?.id,
            kecamatan_id: form?.kecamatan?.id,
          });

          setKelurahan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKelurahan(false);
    }

    fetchKelurahan();
  }, [form.kecamatan.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setError((error) => ({
      ...error,
      [name]: "",
    }));

    switch (name) {
      case "provinsi":
        setForm((form) => ({
          ...form,
          [name]: value,
          kota: {},
          kecamatan: {},
          kelurahan: {},
        }));
        setKota([]);
        setKecamatan([]);
        setKelurahan([]);
        break;
      case "kota":
        setForm((form) => ({
          ...form,
          [name]: value,
          kecamatan: {},
          kelurahan: {},
        }));
        setKecamatan([]);
        setKelurahan([]);
        break;
      case "kecamatan":
        setForm((form) => ({
          ...form,
          [name]: value,
          kelurahan: {},
        }));
        setKelurahan([]);
        break;
      case "kelurahan":
        setForm((form) => ({
          ...form,
          [name]: value,
        }));
        break;
      default:
        setForm((form) => ({
          ...form,
          [name]: value,
        }));

        break;
    }
  };

  const validate = () => {
    const newError = { ...error };

    const {
      judul,
      nama_penerima,
      no_telepon,
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      alamat_lengkap,
    } = form;

    if (!judul) {
      newError.judul = "Judul wajib diisi";
    }

    if (!nama_penerima) {
      newError.nama_penerima = "Nama penerima wajib diisi";
    }

    if (!no_telepon) {
      newError.no_telepon = "Nomor telepon wajib diisi";
    } else if (!Number(no_telepon)) {
      newError.no_telepon = "Nomor telepon tidak valid";
    }

    if (!provinsi.name) {
      newError.provinsi = "Provinsi wajib diisi";
    }

    if (!kota.name) {
      newError.kota = "Kota wajib diisi";
    }

    if (!kecamatan.name) {
      newError.kecamatan = "Kecamatan wajib diisi";
    }

    if (!kelurahan.name) {
      newError.kelurahan = "Kelurahan wajib diisi";
    }

    if (!alamat_lengkap) {
      newError.alamat_lengkap = "Detail alamat wajib diisi";
    }

    return newError;
  };

  const handleSimpan = async () => {
    const findErrors = validate();
    const { judulLainnya, ...formRest } = form;

    if (Object.values(findErrors).some((err) => err !== "")) {
      setError(findErrors);
    } else {
      try {
        setIsSubmitting(true);

        const data = {
          ...formRest,
          koordinat: titik_maps
            ? new GeoPoint(currentPos?.lat, currentPos?.lng)
            : "",
          judul: form.judul === "lainnya" ? form.judulLainnya : form.judul,
          created_at: Date.now(),
          updated_at: Date.now(),
          type: "sellerapp",
        };

        const newAlamat = await alamatRef.add(data);
        await addToCart({ id: newAlamat.id });
        // console.log(data);
        if (!profil.alamat_utama) {
          const usersCol = firestore.collection(`users`);
          await usersCol
            .doc(profil.id)
            .set({ alamat_utama: newAlamat.id }, { merge: true });
        }
        setIsSubmitting(false);
        // console.log("ini resullt => ", newAlamat.id);
        enqueueSnackbar("Alamat Berhasil Diperbarui", {
          variant: "success",
        });
        history.push("/cart");
      } catch (err) {
        console.log(err.message);
        enqueueSnackbar("Alamat Gagal Diperbarui", {
          variant: "error",
        });
      }
    }
  };

  const menuAlamat = [...menu_alamat?.judul, "lainnya"];

  return (
    <Dialog
      open={openForm}
      onClose={closeForm}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={closeForm}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Tambah Alamat</Typography>
        </div>
      </DialogTitle>
      {/* <Gap height={30} /> */}
      <DialogContent dividers style={{ padding: 10 }}>
        {/* <div style={{ marginTop: 10, marginBottom: 60 }}> */}
        {/* <InputLabel id="demo-simple-select-label">Judul</InputLabel> */}
        <Gap height={10} />
        <Autocomplete
          id="judul"
          name="judul"
          required
          disableClearable
          value={form.judul}
          onChange={(event, value) => {
            handleChange({ target: { name: "judul", value } });
          }}
          disabled={isSubmitting}
          options={menuAlamat}
          // getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Judul"
              fullWidth
              InputLabelProps={{ shrink: true }}
              helperText={error?.judul}
              error={error?.judul ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        {form.judul === "lainnya" ? (
          <>
            <TextField
              name="judulLainnya"
              label="Judul Lainnya"
              fullWidth
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={form.judulLainnya}
              helperText={error.judul}
              error={error.judul ? true : false}
              disabled={isSubmitting}
              autoComplete="off"
            />
            <Gap height={15} />{" "}
          </>
        ) : null}
        <TextField
          name="nama_penerima"
          label="Nama Penerima"
          fullWidth
          placeholder="Contoh: Bu Suci"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.nama_penerima}
          helperText={error.nama_penerima}
          error={error.nama_penerima ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <TextField
          name="no_telepon"
          label="Nomor Telepon"
          fullWidth
          placeholder="Nomor Telepon Penerima"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.no_telepon}
          helperText={error.no_telepon}
          error={error.no_telepon ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
          type="tel"
        />
        <Gap height={15} />
        <Autocomplete
          id="provinsi"
          name="provinsi"
          required
          disableClearable
          value={form.provinsi}
          onChange={(event, value) => {
            handleChange({ target: { name: "provinsi", value } });
          }}
          disabled={isSubmitting}
          options={provinsi}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Provinsi"
              InputLabelProps={{ shrink: true }}
              helperText={error?.provinsi}
              error={error?.provinsi ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kota"
          name="kota"
          required
          disableClearable
          value={form.kota}
          onChange={(event, value) => {
            handleChange({ target: { name: "kota", value } });
          }}
          disabled={isSubmitting}
          options={kota}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Kota"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kota}
              error={error?.kota ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kecamatan"
          name="kecamatan"
          required
          disableClearable
          value={form.kecamatan}
          onChange={(event, value) => {
            handleChange({ target: { name: "kecamatan", value } });
          }}
          disabled={isSubmitting}
          options={kecamatan}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Kecamatan"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kecamatan}
              error={error?.kecamatan ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kelurahan"
          name="kelurahan"
          required
          disableClearable
          value={form.kelurahan}
          onChange={(event, value) => {
            handleChange({ target: { name: "kelurahan", value } });
          }}
          disabled={isSubmitting}
          options={kelurahan}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Kelurahan"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kelurahan}
              error={error?.kelurahan ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <TextField
          name="alamat_lengkap"
          label="Detail Alamat"
          fullWidth
          inputProps={{
            maxLength: "85",
          }}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.alamat_lengkap}
          helperText={error.alamat_lengkap}
          error={error.alamat_lengkap ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <FormControlLabel
          control={
            <Checkbox
              disabled={isSubmitting}
              onChange={togglecheckboxTitikAlamat}
              checked={titik_maps}
              name="titik_maps"
              color="default"
            />
          }
          label="Pilih Titik Maps (Opsional)"
        />
        <Gap height={15} />
        {titik_maps ? (
          <>
            <Maps
              center={position}
              currentPos={currentPos}
              setCurrentPos={setCurrentPos}
            />
            <Gap height={15} />
          </>
        ) : (
          ""
        )}
        <TextField
          name="destination_direction"
          label="Patokan (opsional)"
          fullWidth
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.destination_direction}
          disabled={isSubmitting}
          autoComplete="off"
        />
        {/* <Gap height={15} />
        {form?.kota?.id === alamat_pusat?.kota?.id && (
          <>
            <p>Pilih Koordinat</p>
            <Maps
              center={position}
              currentPos={currentPos}
              setCurrentPos={setCurrentPos}
            />
          </>
        )} */}
        <Gap height={15} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSimpan}
          disabled={isSubmitting}
        >
          Simpan
        </Button>
        <Gap height={10} />
      </DialogContent>
    </Dialog>
  );
}

export default DialogFormAlamat;
